<ng-template [ngIf]="isLoad" [ngIfElse]="loading">
  <ng-template [ngIf]="error" [ngIfElse]="load">
    </ng-template>
    <ng-template #load>
  <div class="row station-detail">
    <div class="col-sm-12">
      <div class="row justify-content-between card-planning">
        <h3 class="col-12 titleBookk bold">{{stationDetail?.name}}</h3>
        <div class="col-sm-auto col-12 row">
          <mat-icon aria-hidden="false" aria-label="Adresse">place</mat-icon>
          <label>{{ 'SEARCH.STATIONDETAILADRESSE' | translate }} : {{stationDetail?.street}} {{stationDetail?.city}}</label>
        </div>
        <div class="col-sm-auto col-12 row">
          <mat-icon *ngIf="stationDetail?.autonomy !== 0" aria-hidden="false" aria-label="Autonomie">ev_station</mat-icon>
          <label *ngIf="stationDetail?.type === 1 && stationDetail?.autonomy !== 0" class="ml-2">{{ 'SEARCH.STATIONDETAILAUTONOMIE' | translate }} : {{stationDetail?.autonomy}}km</label>
          <label *ngIf="stationDetail?.type === 0 && stationDetail?.autonomy !== 0" class="ml-2">{{ 'SEARCH.STATIONDETAILPUISSANCE' | translate }} : {{stationDetail?.autonomy}}kW</label>
          <label *ngIf="stationDetail?.type === 7 && stationDetail?.autonomy !== 0" class="ml-2">{{ 'SEARCH.STATIONDETAILPUISSANCE' | translate }} : {{stationDetail?.autonomy}}kW</label>
        </div>
        <h4 class="col-12 titleBookk bold">{{ 'SEARCH.STATIONDETAILDISPONIBILITE' | translate }}</h4>
        <div class="col-12 card-planning">
          <div class="row planning">
            <table class="col-12">
              <thead>
                <tr>
                  <th colspan="48" *ngFor="let day of dayCount;">{{day | date:"dd/MM/yy"}}</th>
                <tr>
                <tr>
                  <th class="hour" colspan="2" *ngFor="let hour of hourCount;"><label>{{hour}}</label></th>
                </tr>
                <tr>
                  <th class="hour" colspan="2" *ngFor="let hour of hourCount;">|</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="content-resa"> </td>

                  <td style="height: 3.5em;" class="content-resa" *ngFor="let availabilitie of availabilities;" [ngClass]="availabilitie">
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-12 mt-1">
          <div class="row justify-content-end">
            <div class="col-md-3 col-12">
              <label class="bold">
                <mat-icon aria-hidden="false" aria-label="Prix">payment</mat-icon>
                {{ 'SEARCH.STATIONDETAILPRICE' | translate }}: {{stationPrice.price}} €
              </label>
            </div>
          </div>
        </div>
        <div *ngIf="stationDetail?.type === 1" class="col-12 mb-1">
          <div class="row justify-content-end ">
            <div class="col-md-3 col-12">
              <label class="bold">
                <mat-icon aria-hidden="false" aria-label="Prix" >payment</mat-icon>
                + {{stationPrice?.extra.KmTTC}} €/km
              </label>
            </div>
          </div>
        </div>
        <div *ngIf="stationDetail?.type === 0 || stationDetail?.type === 7" class="col-12 mb-1">
          <div class="row justify-content-end ">
            <div class="col-md-3 col-12">
              <label class="bold">
                <mat-icon aria-hidden="false" aria-label="Prix" >payment</mat-icon>
                + {{stationPrice?.extra.KwhTTC}} €/kWh
              </label>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row  justify-content-end">
            <ng-template [ngIf]="canReserved" [ngIfElse]="cantReserved"><button class="col-md-3 col-12" mat-flat-button color="primary"
                (click)='stationSelected()'>{{ 'SEARCH.BOUTONRESERVER' | translate }}</button></ng-template>
            <ng-template #cantReserved><button class="col-md-3 col-12 disablebtn" mat-stroked-button disabled
                color="primary">{{ 'SEARCH.BOUTONRESERVER' | translate }}</button></ng-template>

          </div>
        </div>
      </div>
    </div>
  </div>
  </ng-template>

</ng-template>
<ng-template #loading>
  <ng-template [ngIf]="error" [ngIfElse]="load">
  </ng-template>
  <ng-template #load>
    <div class="row justify-content-center">
      <div class="col-4">
        <!-- <mat-icon style="width: 100%; height: 100%; " svgIcon="{{type}}"></mat-icon> -->
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    </div>
  </ng-template>
</ng-template>
